export const ACTION_TYPE = 'actionType';